export default [
  {
    name: 'homepage',
    path: '/',
    meta: {
      needParticle: true,
    },
    component: () => import('@/views/homepage/index2'),
  },
  {
    name: 'homepage-mobile',
    path: '/home_mobile',
    component: () => import('@/views/mobile/home_mobile'),
  },
  {
    name: 'download',
    path: '/download',
    component: () => import('@/views/download/index'),
  },
  {
    name: 'genesisBoxes',
    path: '/genesisBoxes',
    component: () => import('@/views/genesisBoxes/index'),
  },
  {
    name: 'catto',
    path: '/catto',
    component: () => import('@/views/catto/index'),
  },
  {
    name: 'share',
    path: '/share',
    component: () => import('@/views/mobile/share'),
  },
  {
    name: 'content',
    path: '/content',
    component: () => import('@/views/mobile/shareOk'),
  },
  {
    name: 'shareVideo',
    path: '/sharevideo',
    component: () => import('@/views/mobile/shareVideo'),
  },
  {
    name: 'video',
    path: '/video',
    component: () => import('@/views/mobile/shareVideoOk'),
  },
  {
    name: 'invite',
    path: '/invite',
    meta: {
      needParticle: false,
    },
    component: () => import('@/views/mobile/invite'),
  },
  {
    name: 'zkMintMobile',
    path: '/zkmint',
    meta: {
      needParticle: false,
    },
    component: () => import('@/views/mobile/zkMint'),
  },
  {
    name: 'lineaprofile',
    path: '/lineaprofile',
    meta: {
      needParticle: false,
    },
    component: () => import('@/views/personal/lineaprofile'),
  },
  {
    name: 'lab',
    path: '/lab',
    component: () => import('@/views/lab'),
    children: [
      {
        name: 'sphinx',
        path: 'sphinx',
        component: () => import('@/views/lab/qa'),
      },
      {
        name: 'sphinxDetail',
        path: 'sphinx/detail',
        component: () => import('@/views/lab/qaDetail'),
      },
    ],
  },
  {
    name: 'personal',
    path: '/personal',
    component: () => import('@/views/personal'),
    meta: {
      needParticle: true,
    },
    children: [
      {
        name: 'assets',
        path: 'assets',
        component: () => import('@/views/personal/assets'),
      },
      {
        name: 'gatedContent',
        path: 'gatedcontent',
        component: () => import('@/views/personal/articleList'),
      },
      {
        name: 'articleDetail',
        path: 'gatedcontent/articleDetail',
        component: () => import('@/views/personal/articleDetail'),
      },
      {
        name: 'zkMint',
        path: 'zkmint',
        component: () => import('@/views/personal/zkMint'),
      },
    ],
  },
  {
    name: 'feed',
    path: '/feed',
    meta: {
      needParticle: true,
    },
    component: () => import('@/views/feed'),
  },
  {
    name: 'leaderboard',
    path: '/leaderboard',
    component: () => import('@/views/leaderboard'),
  },
  {
    name: 'demo',
    path: '/demo',
    meta: {
      needParticle: false,
    },
    component: () => import('@/views/personal/demo'),
  },
  {
    name: 'preview',
    path: '/preview',
    meta: {
      needParticle: false,
    },
    component: () => import('../components/common/makedownPreview.vue'),
  },
];
